import React from "react";
import { VERSION, EXT_TITLE } from "../../../../config/consts";
import * as Styled from "./styled";
import LogoIcon from "../../../../components/UI/Icons/LogoIcon";
import config from "../../../../config/config";
import Logo2Icon from "../../../../assets/img/logos/espy.png";

const MainLogo = () => (
  <Styled.HeaderLogo>
    <Styled.NavbarBrand to="/">
      <img style={{maxHeight: '40px'}} src={Logo2Icon}/>
      {/*<LogoIcon
        type={config.headerLogo}
        title={`${config.appTitle || EXT_TITLE} ${VERSION}`}
        style={{maxHeight: '40px'}}
      />*/}
    </Styled.NavbarBrand>
  </Styled.HeaderLogo>
);

export default MainLogo;
